import styled from 'styled-components'

export const ContainerAtom = styled.div<{
  $position?: string
  $padding?: string
}>`
  position: ${({ $position }) => $position || 'relative'};
  padding: ${({ $padding }) => $padding || undefined};
`
